import {
  FileSyncOutlined,
  MessageOutlined,
  SolutionOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Badge } from 'antd';

import { checkRegistrationAvailable } from '../../common/helpers';
import {
  UserInfo,
  UserStatus,
} from '../../pages/Registration/Registration.interfaces';
import { pages } from '../../routes/Routes.constants';
import { PagesLabels, PagesTypes } from '../../routes/Routes.interfaces';

export const getMenuItems = (
  handleLinkClick: (link: string) => void,
  userInfo: UserInfo | null,
  countMessages: number,
  onCloseMobMenu: () => void,
) => {
  const handleMobileClick = (link: string) => {
    handleLinkClick(link);
    onCloseMobMenu();
  };

  const menuItems: Array<{
    icon: React.ReactNode;
    key: string;
    label: React.ReactNode;
    onClick: () => void;
  }> = [
    {
      icon: <UserOutlined />,
      key: pages[PagesTypes.PROFILE].path,
      label: 'Профиль',
      onClick: () => handleMobileClick(pages[PagesTypes.PROFILE].path),
    },
  ];

  if (checkRegistrationAvailable(userInfo)) {
    menuItems.push({
      icon: <SolutionOutlined />,
      key: pages[PagesTypes.DOC].path,
      label: 'Регистрация',
      onClick: () => handleMobileClick(pages[PagesTypes.DOC].path),
    });
  }

  //icon: <MessageOutlined />,

  // TODO: возможно лучше добавить типы кабинетов в enum asia и asteri
  // if (IS_ASTERI_LK) {
  if (userInfo?.status === UserStatus.ACTIVE) {
    menuItems.push({
      icon: <FileSyncOutlined />,
      key: pages[PagesTypes.ORDERS].path,
      label: 'Заявки',
      onClick: () => handleMobileClick(pages[PagesTypes.ORDERS].path),
    });

    menuItems.push({
      icon:
        countMessages === 0 ? (
          <MessageOutlined />
        ) : (
          <Badge
            style={{
              padding: '4px 4px 0px 4px',
            }}
            count={countMessages}
            showZero
          />
        ),
      key: pages[PagesTypes.SUPPORT_CHAT].path,
      label: PagesLabels.SUPPORT_CHAT,
      onClick: () => handleMobileClick(pages[PagesTypes.SUPPORT_CHAT].path),
    });
  }

  return menuItems;
};

export const getDefaultSelectedKey = (pathname: string): string[] => {
  if (pages[PagesTypes.PROFILE].path.includes(pathname)) {
    return [pages[PagesTypes.PROFILE].path];
  }

  if (pages[PagesTypes.ORDERS].path.includes(pathname)) {
    return [pages[PagesTypes.ORDERS].path];
  }

  if (pages[PagesTypes.DOC].path.includes(pathname)) {
    return [pages[PagesTypes.DOC].path];
  }

  return [];
};
